<template>
  <div id="roomList">
    <navbar></navbar>
    <div class="container">
      <create-room></create-room>
    </div>
  </div>
</template>

<script>
import CreateRoom from "./CreateRoom.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { CreateRoom, Navbar },
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>
